import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NETWORK_SERVICE, NetworkServiceV2} from '@netfoundry-ui/shared/apiv2';
import { AuthorizationService } from '@netfoundry-ui/shared/authorization';
import { GrowlerData, GrowlerService } from '@netfoundry-ui/shared/growler';
import { NetworkControllerInfoComponent } from '@netfoundry-ui/feature/network-controller-info';
import { ConfirmComponent } from '@netfoundry-ui/ui/confirm';
import {
    Environment,
    ENVIRONMENT,
    NetworkV2,
} from '@netfoundry-ui/shared/model';
import {
    ApiService,
    ErrorHistoryService,
    HTTP_CLIENT,
    LoggerService,
    TokenService,
} from '@netfoundry-ui/shared/services';
import { throwError as observableThrowError } from 'rxjs/internal/observable/throwError';

@Injectable({
    providedIn: 'root',
})
export class NetworkMigrateService {
    networkVersions: any[] = [];
    apiUrl: string;

    constructor(
        @Inject(HTTP_CLIENT) private http: HttpClient,
        private router: Router,
        public logger: LoggerService,
        public growlerService: GrowlerService,
        public apiService: ApiService,
        private tokenService: TokenService,
        private errorHistoryService: ErrorHistoryService,
        private authorizationSvc: AuthorizationService,
        public dialogForm: MatDialog,
        @Inject(NETWORK_SERVICE) public networkService: NetworkServiceV2,
        @Inject(ENVIRONMENT) private environment: Environment,
    ) {
        // migrate is only for v7 to v8 networks currently
        this.apiUrl = environment.v2apiUrl;
    }

    requestUpgrade(network: NetworkV2) {
        if (this.authorizationSvc.canMigrateNetwork(network.id)) {
          let dialogRef
          // if the network has an alternate domain name, show the info for the DNS networks that need to be created
          if(network.networkController.alternateDomainName != null) {
            dialogRef = this.dialogForm.open(NetworkControllerInfoComponent, {
                data: { 
                  network: network,
                  isMigrating: true,
                  isSupport: true
                },
                height: '500px',
                width: '800px',
                autoFocus: false,
            });
          } else {
            const data = {
              title: 'Migrate Network to V8',
              appendId: 'NetworkMigrate',
              action: 'Yes, Migrate to V8',
              cancelAction: 'No, get me out of here',
              subtitle: `Are you sure you want to migrate this network to V8? All components will be temporarily unavailable.`,
              isTimeoutWarning: false,
            };
            dialogRef = this.dialogForm.open(ConfirmComponent, {
                data: data,
                height: '200px',
                width: '600px',
                autoFocus: false,
            });
          }

          dialogRef.afterClosed().subscribe((result) => {
            if(result) {
              this.initiateMigration(network);
            }     
          });
            
        }
    }

  public validateMigrate(options: any) {
      this.apiService.setCurrentNetwork(options.network);
      let h: HttpHeaders = this.setHeaders();
      h = h.append('nf-validate', 'true');
        return  this.http
              .post(`${this.apiUrl}networks/${options.network.id}/migrate`, {}, {
                  headers: h,
              })
              .toPromise();
  }

    /**
     * Generic error handler for bad requests
     */
    protected handleError(scope: any, error: HttpErrorResponse, silenceCodes?: number[]) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            scope.logger.error('HTTP error occurred:', error.error);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            scope.logger.error(`HTTP response returned code ${error.status}`, error.error);
        }

        let errorMessage = error.message;
        if (error.error && error.error[0] && error.error[0]['message']) {
            errorMessage = error.error[0]['message'];
        }
        let displayGrowler = true;
        if (silenceCodes != null && silenceCodes.indexOf(error.status) > -1) {
            displayGrowler = false;
        } else {
            this.errorHistoryService.addError(error.message);
        }
        if (displayGrowler) {
            this.growlerService.show(new GrowlerData('error', 'Error', 'An error occured', errorMessage));
        }
        return observableThrowError(error);
    }


    private async migrate(network: NetworkV2) {
        
        this.apiService.setCurrentNetwork(network);
        
        this.http
            .post(`${this.apiUrl}networks/${network.id}/migrate`, {}, {
                headers: this.setHeaders(),
            })
            .toPromise()
            .then((result) => {
                this.router.navigate(['/process-executions']);
            })
            .catch((error) => this.handleError(this, error));

    }

    

    private initiateMigration(network: NetworkV2) {
      this.migrate(network);
      this.growlerService.show(
        new GrowlerData(
          'success',
          'Success',
          'Migration initiated',
          'V8 Migration was initiated successfully.<a href="' +
          this.router.createUrlTree(['/process-executions']).toString() +
            '">Click here to find out more.</a>'
          )
      );
                
    }

    private setHeaders(): HttpHeaders {
        // getting the access token
        const tokenResponse = this.tokenService.getAccessToken();

        // value to return
        let headers;

        if (!tokenResponse?.expired && tokenResponse?.accessToken) {
            // if the token was not expired and there was an access token returned, set the headers using the access token
            headers = new HttpHeaders().set('Authorization', 'Bearer ' + tokenResponse.accessToken);
        } else {
            // if there were no headers return a new set of HTTP headers without an access token
            headers = new HttpHeaders();
        }

        if (headers != null) {
            return headers.append('Content-Type', 'application/json');
        } else {
            return headers;
        }
    }
}
